import { imgSrc } from "../lib/api";

export const Avatar = ({ src, name, size = 96, ring = true, testId }) => {
  const initials = (name || "?").slice(0, 2).toUpperCase();
  return (
    <div
      data-testid={testId}
      className={`flex items-center justify-center overflow-hidden rounded-full bg-rox-gray ${ring ? "ring-2 ring-rox-off/80 ring-offset-4 ring-offset-rox-black" : ""}`}
      style={{ width: size, height: size }}
    >
      {src ? (
        <img src={imgSrc(src)} alt={name} className="h-full w-full object-cover" />
      ) : (
        <span className="font-display uppercase text-rox-off" style={{ fontSize: size * 0.36 }}>
          {initials}
        </span>
      )}
    </div>
  );
};
